import * as classnames from 'classnames';
import * as React from 'react';
import { AccordionStyle, AccordionLightStyle } from './AccordionStyle';
import { ArrowKeyCodes } from '../constants/ArrowKeyCodes';

export interface IAccordionSlideProps {
    openIndex?: number;
    className?: string;
    isLigthAccordion?: boolean;
    onChange?(openIndex: number): void;
    dataTestId?: string;
}

export interface IAccordionSlideState {
    openIndex: number;
    selectedIndex: number;
}

export class Accordion extends React.Component<IAccordionSlideProps, IAccordionSlideState> {
    private childRefs: { [index: number]: React.RefObject<HTMLElement> } = {};

    constructor(props: IAccordionSlideProps) {
        super(props);
        this.onChange = this.onChange.bind(this);

        this.state = {
            openIndex: this.props.openIndex !== undefined ? this.props.openIndex : -1,
            selectedIndex: this.props.openIndex !== undefined ? this.props.openIndex : -1
        };
    }

    private onChange(openIndex: number) {
        if (this.state.selectedIndex !== openIndex) {
            this.setState({
                selectedIndex: openIndex
            });
        }
        // openIndex if -1 there are no slide open
        const openSlideIndex = this.state.openIndex === openIndex ? -1 : openIndex;
        this.setState({
            openIndex: openSlideIndex
        });
        if (this.props.onChange) {
            this.props.onChange(openIndex);
        }
    }

    private onChildKeyDown = (event: React.KeyboardEvent, sourceIndex: number) => {
        const itemsCount = React.Children.toArray(this.props.children).length;
        let navigateIndex = -1;

        switch (event.keyCode) {
            case ArrowKeyCodes.UP:
            case ArrowKeyCodes.LEFT:
                event.preventDefault();
                navigateIndex = sourceIndex === 0 ? itemsCount - 1 : sourceIndex - 1;
                break;

            case ArrowKeyCodes.DOWN:
            case ArrowKeyCodes.RIGHT:
                event.preventDefault();
                navigateIndex = sourceIndex + 1 >= itemsCount ? 0 : sourceIndex + 1;
                break;
            default:
        }

        if (navigateIndex >= 0) {
            this.onChange(navigateIndex);
            const { current } = this.childRefs[navigateIndex];
            current && current.focus();
        }
    };

    private enhanceSection() {
        if (!this.props.children) {
            return null;
        }

        return React.Children.map(this.props.children, (child: React.ReactChild, index: number) => {
            return React.isValidElement(child)
                ? React.cloneElement(child, {
                      ref: this.childRefs[index] || (this.childRefs[index] = React.createRef()),
                      key: index,
                      index,
                      isOpen: this.state.openIndex === index,
                      onChange: this.onChange,
                      onKeyDown: this.onChildKeyDown,
                      isSelected: this.state.selectedIndex === index
                  })
                : child;
        });
    }

    public render() {
        const { isLigthAccordion, dataTestId } = this.props;
        const AccordionWrapper = isLigthAccordion ? AccordionLightStyle : AccordionStyle;

        const accordionClass = classnames(
            this.props.className,
            {
                'elc-accordion-light': isLigthAccordion,
                'elc-accordion': !isLigthAccordion
            },
            'js-accordion'
        );

        return (
            <AccordionWrapper
                className={accordionClass}
                data-test-id={dataTestId || 'accordion_wrapper'}
            >
                {this.enhanceSection()}
            </AccordionWrapper>
        );
    }
}
